import Vue from "vue";
import Vuetify from "vuetify/lib";
import { VDataTable, VDataFooter } from "vuetify/lib";
// v-data-table 전역 기본값: 50개 표시, 단위 옵션 [50, 100, 200, 전체]
VDataTable.options.props.itemsPerPage.default = 50;
VDataFooter.options.props.itemsPerPageOptions.default = () => [50, 100, 200, -1];
Vue.use(Vuetify);
export default new Vuetify({
    theme: {
        dark: false,
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: "#1976D2",
                secondary: "#424242",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FFC107",
            },
        },
    },
    // 브레이크포인트 설정 추가
    breakpoint: {
        thresholds: {
            xs: 600,
            sm: 960,
            md: 1280,
            lg: 1920,
        },
        scrollBarWidth: 16,
    },
});
